import React from 'react';
import { Typography, useMediaQuery } from 'fronton-react';
import { useRecoilValue } from 'recoil';
import { styled } from 'linaria/react';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { RoomParams } from './components/RoomParams';
import { Hints } from './components/Hints';
import { Result } from './components/Result';
import { LaminateCalculateBannerResult } from './components/LaminateCalculateBanner';
import { AddToCart } from './components/AddToCart';
import { BasketLogicSnackbar } from './components/BasketLogicSnackbar';

export const CalculationForm = () => {
  const dimensions = useRecoilValue(dimensionsAtom);

  const { complimentaryProductInfo } = dimensions;

  const isMobile = useMediaQuery({
    maxWidth: 767,
  });

  const calculationHeaderText = complimentaryProductInfo.length
    ? `Рассчитали количество и\u00A0подобрали расходники и\u00A0инструменты`
    : 'Рассчитали количество товара';

  return (
    <CalculationFormContainer>
      <ParamsHeaderContainer>
        <Typography variant={isMobile ? 'h2' : 'h1'} color="text-primary">
          {calculationHeaderText}
        </Typography>
      </ParamsHeaderContainer>

      <CalculationFormRow>
        <CalculationFormColumn>
          <RoomParams />
          <Result />
          <LaminateCalculateBannerResult />
        </CalculationFormColumn>
        <CalculationFormColumnLeft>
          <AddToCart />
        </CalculationFormColumnLeft>
      </CalculationFormRow>
      <BasketLogicSnackbar />
      <Hints />
    </CalculationFormContainer>
  );
};

const CalculationFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
  height: 100%;
  margin-top: var(--space-200);

  @media (max-width: 768px) {
    gap: var(--space-250);
  }
`;

const ParamsHeaderContainer = styled.div`
  width: 100%;
`;

const CalculationFormColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 2;
`;
const CalculationFormColumnLeft = styled.div`
  display: flex;
  flex-direction: column;

  @media (--to-tablet) {
    position: relative;
    bottom: var(--space-200);
    margin-top: auto;
  }
`;

const CalculationFormRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: var(--space-500);

  & > div {
    max-width: 548px;
    @media (max-width: 1024px) {
      max-width: 100%;
    }
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    height: 100%;
    & > div {
      max-width: 100%;
    }
  }
`;
